import {
  CashoutResponseApiWithTimer,
  setIdsRealTimeCashout,
  setSelectedBet,
} from 'features/dashboard/myBets/myBetSlice';
import { Keyboard, Pagination } from 'swiper/modules';
import { RootState, useAppDispatch, useTypedSelector } from 'lib/centralStore';
import { ScommesseResponseApi, ScommesseResponseApiItem } from 'lib/api/scommesseResponseApi';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useEffect, useRef } from 'react';

import { MieScommesseTableRowMobile } from 'components/mieScommesseTableRowMobile';
import { TableFieldProps } from 'components/mieScommesseTableRow/MieScommesseTableRow';
import { isRealTimeCashoutEnabled } from 'utility/constant';
import { isTruthy } from 'utility/functions';
import { populateItemMieScommesseDashboardRow } from 'utility/dashboard/functions';
import styles from './MieScommesseWrapperMobile.module.scss';
import { useGetLabelByKey } from 'hooks/useLingUI';
import { useRealTimeCashoutQuery } from 'features/api/userSlice';
import { useRouter } from 'next/router';
import useWindowSize from 'hooks/useWindowSize';

export type MieScommesseWrapperMobileProps = {
  arrayData?: TableFieldProps[][];
  internalClassName?: string;
  scommesseResponse?: ScommesseResponseApi;
  labels: {
    labelSingola?: string;
    labelEventi: string | undefined;
    labelPossibileVincita: string | undefined;
    labelImportoGiocato: string | undefined;
    labelSport: string | undefined;
    labelSistema: string | undefined;
    labelMultipla: string | undefined;
    labelConfermaCashout: string | undefined;
  };
};

export const MieScommesseWrapperMobile = ({
  arrayData,
  internalClassName,
  scommesseResponse,
  labels,
}: MieScommesseWrapperMobileProps) => {
  const dispatch = useAppDispatch();
  const router = useRouter();
  const { isMobile } = useWindowSize();

  const { blockedIdsRealTimeCashout, idsRealTimeCashout } = useTypedSelector(({ myBets }: RootState) => myBets);
  const blockedIdsRealTimeCashoutRef = useRef<CashoutResponseApiWithTimer[]>([]);
  const labelCashOut = useGetLabelByKey('cashout')!;

  const idsRealTimeCashoutRef = useRef<string[]>([]);

  useEffect(() => {
    if (scommesseResponse?.items?.slice(0, 6) && isRealTimeCashoutEnabled) {
      const ids = (scommesseResponse?.items ?? [])
        .slice(0, 6)
        .filter((item: ScommesseResponseApiItem) => item.hasCashout && item.idBiglietto)
        .map((item) => item.idBiglietto!);
      dispatch(setIdsRealTimeCashout(ids));
      idsRealTimeCashoutRef.current = ids;
    }
  }, [scommesseResponse, dispatch]);

  const { data: cashoutResponse, isLoading: isLoadingCashout } = useRealTimeCashoutQuery(idsRealTimeCashout, {
    pollingInterval: 5000,
    skip: idsRealTimeCashout.length === 0 || !isRealTimeCashoutEnabled,
    refetchOnMountOrArgChange: true,
  });

  const goToDetail = (item: ScommesseResponseApiItem) => {
    if (item) {
      dispatch(setSelectedBet({ ...item, verticale: 'sport' }));
      router.push(`/dashboard/le-mie-scommesse`);
    }
  };

  return isMobile ? (
    <Swiper
      slidesPerView={1}
      spaceBetween={30}
      grabCursor={true}
      updateOnWindowResize={true}
      watchOverflow={true}
      keyboard={{
        enabled: true,
      }}
      className={styles.betSwiper}
      pagination={{
        clickable: true,
        renderBullet: (index, className) => {
          return '<span class="' + styles.bulletBanner + ' ' + className + '">' + '</span>';
        },
      }}
      modules={[Keyboard, Pagination]}
    >
      {isTruthy(scommesseResponse?.items?.length) &&
        scommesseResponse?.items?.slice(0, 6).map((item, i) => {
          const data: Array<TableFieldProps> = populateItemMieScommesseDashboardRow({
            item,
            labels,
            dispatch,
            cashoutResponse,
            blockedIdsRealTimeCashout,
            idsRealTimeCashoutRef,
            blockedIdsRealTimeCashoutRef,
            labelCashOut,
          });

          return (
            <SwiperSlide key={i}>
              <MieScommesseTableRowMobile
                internalClassName={internalClassName}
                columns={data}
                onClick={() => goToDetail(item)}
              />
            </SwiperSlide>
          );
        })}
    </Swiper>
  ) : (
    arrayData?.map((data, i) => {
      return (
        <SwiperSlide key={i}>
          <MieScommesseTableRowMobile internalClassName={internalClassName} columns={data} />
        </SwiperSlide>
      );
    })
  );
};
